module.exports = ".full-width {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/hojadeseguimiento/planactuacion/planactuaciondetalle/planActuaciondetalle.component.scss
// module id = ./src/app/consulta/hojadeseguimiento/planactuacion/planactuaciondetalle/planActuaciondetalle.component.scss
// module chunks = main